var _style, _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.6891,
    y1: 256,
    x2: 448.2112,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.8,71.5h-3.7V18.9c0-4.1-3.3-7.4-7.4-7.4h-77.1c-4.1,0-7.4,3.3-7.4,7.4v52.6h-4.4c-4.1,0-7.4,3.3-7.4,7.4 v69.6c0,17.3,14.2,31.9,31.1,31.9h19.3v173.4c0,35.3-13.7,68.4-38.6,93.3c-24.5,24.5-58.8,38.6-94,38.6 c-72.3,0-131.1-61.2-131.1-136.3v-45.9h10.4c11.3,0,20.3-8.1,21.4-19.2l10.4-90.4c0.2-2.1-0.4-4.2-1.8-5.8 c-1.4-1.6-3.4-2.5-5.5-2.5h-5.9v-50.4c0-4.1-3.3-7.4-7.4-7.4H83.7c-4.1,0-7.4,3.3-7.4,7.4v50.4h-5.2c-2.1,0-4.1,0.9-5.5,2.5 c-1.4,1.6-2.1,3.7-1.8,5.8l10.4,90.3c1.1,11,10,19.3,20.7,19.3h10.4v45.9c0,83.3,65.5,151.1,146,151.1c39.1,0,77.2-15.6,104.5-42.9 c27.7-27.7,42.9-64.5,42.9-103.8V180.4h18.5c17.5,0,31.1-13.7,31.1-31.1V78.9C448.2,74.8,444.9,71.5,440.8,71.5z M91.1,142.6h43v43 h-43V142.6z M88.8,282.6l-9.4-82.1h67.1l-9.4,82.2c-0.4,3.5-3,5.9-6.7,5.9H94.8C91.7,288.6,89.2,286.1,88.8,282.6z M433.4,86.3 v19.3h-85.2V86.3H433.4z M360,26.3h62.2v45.2H360V26.3z M417.1,165.6h-52.6c-8.7,0-16.3-8-16.3-17v-28.2h85.2v28.9 C433.4,158.6,426.4,165.6,417.1,165.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.7529,
    y1: 49.2943,
    x2: 398.5705,
    y2: 49.2943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 383.8,
    y: 41.9,
    className: "st1",
    width: 14.8,
    height: 14.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.18,
    y1: 164.1312,
    x2: 119.9976,
    y2: 164.1312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.2,
    y: 156.7,
    className: "st2",
    width: 14.8,
    height: 14.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.294ad1f51aaf206790611dd2d0cec234.svg";
export { ForwardRef as ReactComponent };